import { useEffect, useMemo, useRef, useState } from 'react';
import { animated, SpringValue } from 'react-spring';
import { useWindowContext } from '@/src/context/WindowContext';
import useT from '@/lib/t';
import { useIsomorphicLayoutEffect } from 'react-use';

const NavBar = () => {
  const [navBarItems, setNavBarItems] = useState<Array<HTMLSelectElement>>([]);

  const t = useT('share.nav');
  const { windowRef, setOnScrollCallBacks } = useWindowContext();
  const focusIdx = useRef(new SpringValue(0)).current;

  useIsomorphicLayoutEffect(() => {
    let temp: HTMLSelectElement[] = [];
    let elements = document.getElementsByTagName('section');
    for (let index = 0; index < elements.length; index++) {
      const element = elements[index] as HTMLSelectElement;
      temp.push(element);
    }
    setNavBarItems(temp);
  }, []);

  const navBarItemNames = useMemo(() => {
    return navBarItems.map((item) => item.id);
  }, [navBarItems]);
  const navBarItemPositions = useMemo(() => {
    return navBarItemNames.map((item) => Math.max(0, (document.getElementById(item)?.offsetTop ?? 0) - 110));
  }, [navBarItemNames]);
  const handleScroll = () => {
    const scrollY = (windowRef.current?.scrollTop ?? 0) + 20 ?? 0;
    if (scrollY <= navBarItemPositions[1]) return focusIdx.start(0);
    if (scrollY >= navBarItemPositions[navBarItemPositions.length - 1])
      return focusIdx.start(navBarItemNames.length - 1);

    for (let index = 1; index < navBarItemPositions.length; index++) {
      if (index >= navBarItemPositions.length) break;
      if (scrollY >= navBarItemPositions[index] && scrollY < navBarItemPositions[index + 1]) {
        focusIdx.start(index);
        break;
      }
    }
  };
  useEffect(() => {
    const id = (Math.random() * 10000).toString();
    setOnScrollCallBacks((callbacks) => {
      callbacks.set(id, handleScroll);
      return new Map(callbacks);
    });
    return () => {
      setOnScrollCallBacks((callback) => {
        callback.delete(id);
        return new Map(callback);
      });
    };
  }, [navBarItemPositions, navBarItemNames]);
  return (
    <div className={'flex flex-col sticky top-0 left-0 mt-16 z-[60] h-16'}>
      <div className={'absolute w-screen right-1/2 transform translate-x-1/2 border-b border-gray300 bg-white'}>
        <div className={'w-full max-w-[90rem] mx-auto'}>
          <div className={'h-16  w-full bg-white pl-8 flex-row flex'}>
            {navBarItemNames?.map((item) => {
              return (
                <div
                  key={item}
                  onClick={() => {
                    let element = document.getElementById(item);
                    windowRef?.current?.scrollTo({
                      top: Math.max((element?.offsetTop ?? 0) - 100, 0),
                    });
                    setTimeout(() => {
                      handleScroll();
                    }, 100);
                  }}
                  className={'px-4 py-3  cursor-pointer  flex items-center'}
                >
                  <p className='text-sm leading-normal text-dark-grey uppercase text-gray900'>{t(item)}</p>
                </div>
              );
            })}
          </div>
          <animated.div
            style={{
              x: focusIdx.to({ range: [0, 1, 2, 3, 4], output: [32, 120, 208, 296, 384] }),
              y: -1,
            }}
            className={'w-22 h-px bg-black'}
          ></animated.div>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
